import { put, select } from "redux-saga/effects";
import http from "axios/index";

import { TOKEN_IS_ACTIVE, VERIFY_USER } from "../../../api/constants";

import {
  removeSession,
  setSession,
  checkUser,
  getEmployees,
  getManagers,
  tokenIsActive,
} from "../../actions";

import { getUrlParams } from "../../../utils/";
import OAuth from "../../../utils/OAuth2";
import moment from "moment";
import swal from "sweetalert2";

const {
  url,
  authorizationPath,
  clientId,
  responseType,
  redirectUri,
  galleryRedirect,
  scope,
} = OAuth;

export function* checkToken() {
  try {
    const urlParams = getUrlParams();
    const urlCode = urlParams.code;
    const urlSource = urlParams.source;

    if (urlSource === "port-dakika") {
      if (urlCode && urlCode !== "undefined") {
        window.localStorage.setItem("code", urlCode);
        swal.showLoading();
        yield put(checkUser({ code: urlCode, redirectUrl: redirectUri }));
      } else {
        // source=port-dakika varken code yoksa, OAuth akışını başlat
        // galleryRedirect kontrolünü atla, doğrudan ana redirectUri kullan
        window.location = `${
          url + authorizationPath
        }?response_type=${responseType}&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
      }
    } else {
      // Normal akış - source parametresi yok veya farklı bir değer
      if (urlCode && urlCode !== "undefined") {
        window.localStorage.setItem("code", urlCode);
        swal.showLoading();
        yield put(checkUser({ code: urlCode, redirectUrl: redirectUri }));
      } else if (window.localStorage.getItem("auth") !== null) {
        const auth = JSON.parse(window.localStorage.getItem("auth"));
        if (auth != null) {
          var getEmployeeInfo = JSON.parse(
            window.localStorage.getItem("employeeInfo")
          );
          const expireDate = window.localStorage.getItem("expireDate");

          const now = moment(moment.now());
          const formattedExpireDate = moment(parseInt(expireDate));
          const duration = now.diff(formattedExpireDate, "seconds");

          if (duration > 0) {
            yield logoutSaga();
          } else {
            const payload = {
              accessToken: getEmployeeInfo.accessToken,
              sso: getEmployeeInfo.sso,
            };
            yield verifyToken({ payload });
          }
        }
      } else {
        const referrer = document.referrer;
        let customRedirectUri = galleryRedirect;
        if (referrer.includes(galleryRedirect)) {
          customRedirectUri = redirectUri;
        }
        window.location = `${
          url + authorizationPath
        }?response_type=${responseType}&client_id=${clientId}&redirect_uri=${customRedirectUri}&scope=${scope}`;
      }
    }
  } catch (error) {
    console.error("Error happened when try to check Token : ", error);
  }
}

export function* verifyToken({ payload }) {
  try {
    const token = payload.accessToken;
    const sso = payload.sso;
    var data = new URLSearchParams();
    data.append("accessToken", token);
    const response = yield http.post(VERIFY_USER, data);
    yield put(tokenIsActive(sso));
    response.data.data.sso = sso;
    yield put(setSession(response.data.data));
    yield put(getEmployees(token));
    yield put(getManagers(token));
    yield put(tokenIsActive(sso));
    swal.close();
  } catch (error) {
    yield logoutSaga();
    console.error("Error happened when try to verify Token.Error : ", error);
  }
}

export function* logoutSaga() {
  try {
    const token = yield select((state) => state.login.auth.access_token); // access_token Redux store'dan
    if (!token) {
      return;
    }
    let body = new URLSearchParams();
    body.append("token", token);
    const response = yield http.post("/logout", body);
    if (response.status === 200) {
      console.info("Logging out in api: ", response.status);
      yield put(removeSession());
    }
  } catch (error) {
    console.error(
      "An error occurred while logging out:",
      error.response?.data || error
    );
    yield put(removeSession());
  }
}

export function* tokenIsActiveSaga({ payload }) {
  try {
    const token = payload.access_token;
    var data = new URLSearchParams();
    data.append("accessToken", token);
    const response = yield http.post(TOKEN_IS_ACTIVE, data);
    const isActive = response.data.data.isActive;
    if (!isActive) {
      yield put(removeSession());
    }
  } catch (error) {
    yield put(removeSession());
    console.error("Error happened when try to verify Token.Error : ", error);
  }
}
